/**
 * BookingStatusService
 * Service for managing booking statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for booking status CRUD operations
 */
export class BookingStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BookingStatusService.DEFAULT_SERVICE_PATH,
            basePath: BookingStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BookingStatusService.DEFAULT_SERVICE_PATH = 'booking-management';
BookingStatusService.BASE_PATH = 'api/booking-statuses';
//# sourceMappingURL=BookingStatusService.js.map